import { render } from "./RoundedPill.vue?vue&type=template&id=48f4c96f"
import script from "./RoundedPill.vue?vue&type=script&lang=js"
export * from "./RoundedPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__